import script from "./anomalyAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./anomalyAudit.vue?vue&type=script&setup=true&lang=js"

import "./anomalyAudit.vue?vue&type=style&index=0&id=0a732246&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a732246"]])

export default __exports__